import { createListenerMiddleware } from "@reduxjs/toolkit";
import { addMiddleware } from "redux-dynamic-middlewares";
import { mapStateSlice } from "./slices";
import { mapMarkers } from "./selectors";

const mapActions = mapStateSlice.actions;

const listenerMiddleware = createListenerMiddleware();

/**
 * Listener middleware for the Redux store that reacts to site plan marker updates.
 *
 * - Listens for the `updateSitePlanMarkers` action.
 * - When triggered, retrieves the current markers from the store.
 * - Filters markers to only those that have a matching communityId in the updated site plans.
 * - Dispatches a custom 'markersUpdated' event on the document body with the filtered markers as event detail.
 *
 * This allows other parts of the application to react to marker updates by listening for the 'markersUpdated' event.
 */
listenerMiddleware.startListening({
  type: mapActions.updateSitePlanMarkers.type,
  effect: (action, listenerApi) => {
    const markers = mapMarkers(listenerApi.getState());
    const sitePlanMap = new Map(action.payload.map(sitePlan => [sitePlan.communityId, sitePlan]));
    const updatedMarkers = markers.filter(marker => sitePlanMap.has(marker.communityId));
    const event = new CustomEvent('markersUpdated', { detail: updatedMarkers });
    document.body.dispatchEvent(event);
  },
});

addMiddleware(listenerMiddleware.middleware);